import { createTheme, responsiveFontSizes } from "@mui/material/styles";
import { itIT } from "@mui/material/locale";
import "../fontStyle.css"; // Import dei font Google

export const testTheme = responsiveFontSizes(
    createTheme(
        {
            // CONFIGURAZIONE FONT
            typography: {
                // Font generale per body, body2, paragrafi (usa il primo disponibile)
                fontFamily: [
                    "Signika", // Font principale per tutto il body
                    "Rubik", // Fallback
                    "-apple-system",
                    "BlinkMacSystemFont",
                    '"Segoe UI"',
                    "Arial",
                    "sans-serif",
                ].join(","),

                // Font specifici solo per headers (diversi dal body)
                h1: { fontFamily: "Rowdies", fontWeight: 700 }, // Solo H1 e H2 usano Rowdies
                h2: { fontFamily: "Rowdies", fontWeight: 600 },
                h3: { fontFamily: "Rowdies", fontWeight: 600 }, // H3+ usano Rubik come il body
                h4: { fontFamily: "Rowdies", fontWeight: 500 },
                h5: { fontFamily: "Rowdies", fontWeight: 500 },
                h6: { fontFamily: "Rowdies", fontWeight: 500 },
                button: { fontFamily: "Rubik", fontWeight: 600 },
            },

            // CONFIGURAZIONE PALETTE
            palette: {
                mode: "light",
                primary: {
                    main: "#d59d66",
                },
                secondary: {
                    main: "#02bcff",
                },
                text: {
                    primary: "#191919",
                    secondary: "#591ac5",
                },
                error: {
                    main: "#FF2222",
                },
                info: {
                    main: "#0289b0",
                },
                success: {
                    main: "#69f0ae",
                },
                divider: "rgba(25,25,25,0.5)",
                background: {
                    default: "#d786ed",
                    paper: "#fff4f4",
                },
            },

            // CONFIGURAZIONE FORME
            shape: {
                borderRadius: 12,
            },

            // CONFIGURAZIONE COMPONENTI
            components: {
                // BUTTON
                MuiButton: {
                    styleOverrides: {
                        root: {
                            borderRadius: 12,
                            fontWeight: 600,
                            textTransform: "uppercase",
                            padding: "10px 20px",
                        },
                        contained: {
                            boxShadow: "0 2px 6px rgba(250, 152, 152, 0.3)",
                            "&:hover": {
                                boxShadow: "0 4px 10px rgba(250, 152, 152, 0.4)",
                            },
                        },
                        outlined: {
                            borderWidth: "1px",
                            "&:hover": {
                                borderWidth: "2px",
                            },
                        },
                    },
                },
                // CARD
                MuiCard: {
                    styleOverrides: {
                        root: {
                            borderRadius: 12,
                        },
                    },
                },
                // TEXTFIELD
                MuiTextField: {
                    styleOverrides: {
                        root: {
                            "& .MuiOutlinedInput-root": {
                                borderRadius: 12,
                            },
                        },
                    },
                },
            },

            // COLORI CUSTOM
            andonStatoPagamento: {
                inLavorazione: "#ffb74d",
                daRichiedere: "#81c784",
                inAttesaPagamento: "#fff176",
                parzialmentePagato: "#a5d6a7",
                pagato: "#66bb6a",
                annullato: "#e0e0e0",
            },
            coloriFiltro: {
                attivo: "#ff6090",
                disattivo: "#ffcdd2",
            },
        },
        itIT
    )
);